<template>
  <a-form :form="form" @submit.prevent="handleConfigInfoSubmit">
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="30">

      <!-- 开门时间 -->
      <a-col :span="16" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.activeTime.activeTimeTitle')}}</h3>
        <a-form-item :label="$t('devicesManaConfig.activeTime.selectTimeConfig')">
          <a-select
            :getPopupContainer="trigger => trigger.parentNode"
            :placeholder="$t('devicesManaConfig.activeTime.selectTimeConfigTxt')"
            mode="multiple"
            v-decorator="[
              'vaildTimes',
              { 
                rules: [
                  { required: true, message: $t('devicesManaConfig.activeTime.selectTimeConfigTxt') }
                ],
                validateTrigger: ['change', 'blur']
              }
            ]"
          >
            <a-select-option v-for="selector in activeTimeConfigs" :key="selector.id" :value="selector.id">
              {{ selector.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>

      <a-col :span="24" :style="{ textAlign: 'right' }">
        <a-button type="primary" html-type="submit" :loading="submitting">{{$t('devicesManaConfig.activeTime.submitBtn')}}</a-button>
        <a-button :style="{ marginLeft: '8px' }" @click="$emit('backList')">{{$t('devicesManaConfig.activeTime.backBtn')}}</a-button>
      </a-col>
    </a-row>
      
  </a-form>
</template>

<script>
import { getAllTimeConfig, getDeviceTimeConfigIds } from '@/api/timeConfig'

export default {
  name: 'ActiveTimeSettingForm',
  components: {},
  props: {
    deviceConfig: {
      type: Object,
      required: true,
      default: null
    },
    deviceId: {
      type: String,
      required: true,
      default: undefined
    }
  },
  data() {
    return {
      lastDeviceId: null,

      // 有效时间选择项集合
      activeTimeConfigs: [],

      form: this.$form.createForm(this),
      submitting: false
    }
  },
  created() {    
    this.getAllActiveTimeConfig()
  },
  activated() {
    if (this.deviceId !== this.lastDeviceId) {
      this.lastDeviceId = this.deviceId 
      this.getThisActiveTimeConfig()
    }
  },
  methods: {
    // 获取所有门禁有效时间
    async getAllActiveTimeConfig() {
      try {
        const res = await getAllTimeConfig()
        // 设置有效时间选择项
        this.activeTimeConfigs = res.data.collection
      } catch (error) {}
    },

    // 获取该门禁的有效时间配置
    async getThisActiveTimeConfig() {
      try {
        const res = await getDeviceTimeConfigIds(this.deviceId)
        this.form.setFieldsValue({ vaildTimes: res.data.collection })
      } catch (error) {}
    },

    // 提交配置信息
    handleConfigInfoSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submitConfig', { values: values.vaildTimes, type: 'setActiveTime' })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>